module.exports = __webpack_public_path__ + "img/icon05.8b473117.png";